import React, { useState } from 'react'

import classes from './EmpCard.scss'
import icons from '../../../../../../icons'
import { withStyles } from '@material-ui/core/styles'
import {
  Grid,
  Checkbox,
  Typography,
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Menu,
  MenuItem,
  Divider
} from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'

import Button from '../../../../../UI/Button/Button'
import Image from '../../../../../Image/Image.js'
import AssignStatus from '../../../CommonContent/AssignStatus/AssignStatus'

function EmpCard({
  recordData,
  actionButtonDisabled,
  copyButtonClicked,
  deleteButtonClicked,
  checked,
  empCheckboxChanged,
  pagePermission
}) {
  const [anchorEl, setAnchorEl] = useState(null)

  const open = Boolean(anchorEl)

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  // const checkDisabled = recordData.structures.every(item => !!item.assigned)

  return (
    <Grid item container xl={2} lg={4} md={4} sm={6} xs={12} justify={'center'}>
      <Card className={classes.EmpCardWrapper}>
        <CardContent className={classes.EmpCard}>
          <CardMedia>
            <Image
              className={classes.Avatar}
              src={recordData?.emp?.image_path}
              imgAlt={recordData.full_name}
            />
          </CardMedia>
          <CardContent className={classes.EmpContent}>
            <Typography variant={'h6'}>{recordData?.emp?.full_name}</Typography>
            <Typography variant={'subtitle1'}>{recordData?.emp?.emp_code}</Typography>
            <Typography variant={'body2'}>{recordData?.org?.org_name}</Typography>
            <Typography variant={'body2'}>{recordData?.level?.level_name}</Typography>
            <Typography variant={'body2'}>{recordData?.position?.position_name}</Typography>
          </CardContent>
          <CardActions disableSpacing className={classes.ActionWrapper}>
            <Checkbox checked={checked} size={'small'} onChange={empCheckboxChanged} />
            <Button
              aria-controls='simple-menu'
              aria-haspopup='true'
              clicked={handleClick}
              variant={'text'}
              style={{
                minWidth: 30,
                minHeight: 30,
                width: 30,
                height: 30,
                borderRadius: '50%'
              }}>
              <FontAwesomeIcon icon={icons.faEllipsisV} />
            </Button>
            <Menu
              id='simple-menu'
              anchorEl={anchorEl}
              keepMounted
              open={open}
              onClose={handleClose}>
              <StyledMenuItem
                onClick={handleClose}
                disabled={actionButtonDisabled || !pagePermission.is_view}
                component={Link}
                to={`/assignment/${recordData?.result_id}`}
                style={{ color: 'inherit' }}>
                <FontAwesomeIcon icon={icons.faEdit} color={'navy'} />
              </StyledMenuItem>
              <StyledMenuItem
                onClick={copyButtonClicked}
                disabled={actionButtonDisabled || !pagePermission.is_add}>
                <FontAwesomeIcon icon={icons.faCopy} color={'orange'} />
              </StyledMenuItem>
              <StyledMenuItem
                onClick={deleteButtonClicked}
                disabled={actionButtonDisabled || !pagePermission.is_delete}>
                <FontAwesomeIcon icon={icons.faTrashAlt} color={'red'} />
              </StyledMenuItem>
            </Menu>
          </CardActions>
        </CardContent>
        <Divider />
        <AssignStatus structures={recordData?.structures} />
      </Card>
    </Grid>
  )
}

const StyledMenuItem = withStyles(theme => ({
  root: {
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`
  }
}))(MenuItem)

export default EmpCard
